import * as end from '../constants/api'
import { axiosInstance } from './axios-instance'

const TodayServices = {
	getToday: ({ userId }) => {
		const urlUserId = `/${userId}`
		return axiosInstance.get(end.getToday + urlUserId).then(res => res.data)
	}
}

export default TodayServices
